import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const AIMLEssentials = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Home / Transaction Analytics</h6>
          <hr />
          <h1 className="banner-title">Transaction Analytics</h1>
          <p>
            Unlock the potential of your transactional <br /> data with
            actionable insights, real-time monitoring, and advanced analytics
            for better decision-making.
          </p>
          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>
        <img
          src="https://img.freepik.com/free-photo/person-looking-finance-graphs_52683-116611.jpg"
          alt="AI and Machine Learning Banner"
          className="banner-image"
        />
      </section>

      <section id="about_pg" className="p_3">
        <div className="container-xl">
          <div className="row about_pg1">
            <div className="col-md-6">
              <div className="about_pg1l mt-5">
                {/* <h6 className="col_yell">
                  Training
                </h6> */}
                <h2 className="mt-3 mb-3">Transaction Analytics</h2>
                <p>
                  Our Transaction Analytics solution empowers businesses to gain
                  actionable insights into their transactional data. Leveraging
                  the power of Tableau, we transform raw data into valuable
                  information that helps drive decision-making. Whether you aim
                  to optimize revenue, understand customer behavior, or detect
                  fraudulent transactions, our solution is tailored to meet your
                  needs.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="about_pg1r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <a href="#">
                      <img
                        src="https://img.freepik.com/free-photo/person-looking-finance-graphs_52683-116611.jpg"
                        className="w-100"
                        alt="Empowering Decisions"
                      />
                    </a>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-3 bg-black text-white">
        <div class="container-xl">
          <div class="mb-4 mt-5">
            <h2 class="section-title text-center">Key Features</h2>
            <div class="row g-4 mt-4">
              <div class="col-md-3">
                <div class="feature-card">
                  <h5>Real-Time Monitoring</h5>
                  <p>
                    Track transactions as they happen to gain immediate
                    insights.
                  </p>
                </div>
              </div>
              <div class="col-md-3">
                <div class="feature-card">
                  <h5>Customizable Dashboards</h5>
                  <p>
                    Interactive Tableau dashboards to visualize data
                    effectively.
                  </p>
                </div>
              </div>
              <div class="col-md-3">
                <div class="feature-card">
                  <h5>Advanced Analytics</h5>
                  <p>
                    Leverage predictive analytics to forecast trends and
                    patterns.
                  </p>
                </div>
              </div>
              <div class="col-md-3">
                <div class="feature-card">
                  <h5>Data Security</h5>
                  <p>
                    Ensure sensitive data is handled with utmost security and
                    privacy.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="about_pg" className="p_3">
        <div className="container-xl">
          <div class="mb-5">
            <h2 class="section-title text-center mt-5">The Advantages</h2>
            <p class="text-center mb-5">
              Discover how Transaction Analytics can revolutionize your business
              processes.
            </p>
            <div class="row g-4 mt-4">
              <div class="col-md-6">
                <div class="advantage-card">
                  <h5>Operational Efficiency</h5>
                  <p>
                    Streamline your business processes and minimize
                    inefficiencies.
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="advantage-card">
                  <h5>Customer Insights</h5>
                  <p>
                    Understand customer preferences to improve engagement and
                    satisfaction.
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="advantage-card">
                  <h5>Enhanced Decision-Making</h5>
                  <p>
                    Make data-driven decisions with accurate and timely
                    analytics.
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="advantage-card">
                  <h5>Cost Optimization</h5>
                  <p>
                    Identify cost-saving opportunities and optimize resource
                    allocation.
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="advantage-card">
                  <h5>Scalable Solutions</h5>
                  <p>
                    Easily scale your analytics as your business grows and
                    evolves.
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="advantage-card">
                  <h5>Regulatory Compliance</h5>
                  <p>
                    Ensure adherence to industry regulations through robust
                    reporting.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="transaction_analytics" className="p_3">
        <div className="container-xl">
          <div className="row analytics-section mt-4 pt-5 pb-5 mx-0 px-4 bg-black text-white">
            <div className="col-md-8">
              <div className="analytics-content">
                <h6 className="">Insights</h6>
                <h2 className="text-white">
                  Transform Your Business with Transaction Analytics
                </h2>
                <p className="text-white mt-3">
                  "Leverage real-time analytics to uncover actionable insights
                  from your transaction data. Optimize operations, improve
                  customer experiences, and drive data-informed strategies with
                  powerful tools like Tableau and AI-driven solutions."
                </p>
                {/* <button className="cta-button mt-3">
            Learn More <span className="arrow">→</span>
          </button> */}
              </div>
            </div>
            <div className="col-md-4">
              <div className="analytics-image">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/transaction-analytics">
                      <img
                        src="https://img.freepik.com/free-photo/business-analytics-dashboard-concept_1098-20706.jpg"
                        className="w-100"
                        alt="Transaction Analytics"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AIMLEssentials;
